export const getDetailsQueryKeys = (entityId) => ({
  details: ["details", { id: entityId }],
});

export const getTimelineLogsQueryKeys = (page, entityId, restParams = {}) => ({
  timelineLogs: ["timeline_logs", { page, id: entityId, ...restParams }],
});

export const getFormResponsesQueryKeys = (formResponsesId) => ({
  formResponses: ["form_responses", { id: formResponsesId }],
});

export const getCommunicationInfoQueryKeys = (communicationInfoId) => ({
  info: ["communication_info", { id: communicationInfoId }],
});
